import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type ModalType = 'terms' | 'privacy' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const year = new Date().getFullYear();
  return <footer className="bg-brand-text text-white/60 py-8 text-center text-sm" data-id="element-23">
      <div className="container mx-auto px-4 space-y-4" data-id="element-24">
        <nav className="flex items-center justify-center gap-6" data-id="element-25">
          <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-26">
            Términos y Condiciones
          </button>
          <span aria-hidden="true" className="text-white/30" data-id="element-27">
            |
          </span>
          <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-28">
            Política de Privacidad
          </button>
        </nav>
        <p data-id="element-29">© {year} Reinicio Metabólico 45+. Todos los derechos reservados.</p>
        <p className="text-white/40 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-30">
          Este producto es un material educativo y no sustituye el consejo
          médico profesional. Los resultados pueden variar según cada persona.
        </p>
      </div>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-31">
        <p data-id="element-32">
          Al adquirir y utilizar el programa "Reinicio Metabólico 45+", aceptas
          los siguientes términos y condiciones. Te recomendamos leerlos con
          atención antes de realizar tu compra.
        </p>
        <h3 className="text-lg font-bold text-brand-text" data-id="element-33">
          1. Naturaleza del producto
        </h3>
        <p data-id="element-34">
          El programa es un producto digital de carácter educativo e
          informativo. Incluye guías, protocolos y materiales descargables
          diseñados para acompañar tu proceso de bienestar. No constituye un
          servicio médico ni un tratamiento personalizado.
        </p>
        <h3 className="text-lg font-bold text-brand-text" data-id="element-35">
          2. Uso de la licencia
        </h3>
        <p data-id="element-36">
          La compra te otorga una licencia personal e intransferible para el uso
          del contenido. Queda prohibida la reproducción, distribución, reventa
          o difusión total o parcial del material sin autorización expresa.
        </p>
        <h3 className="text-lg font-bold text-brand-text" data-id="element-37">
          3. Responsabilidad
        </h3>
        <p data-id="element-38">
          Los resultados descritos son ilustrativos y pueden variar según las
          características individuales de cada persona. Antes de iniciar
          cualquier cambio en tu alimentación o actividad física, te
          recomendamos consultar con un profesional de la salud.
        </p>
        <h3 className="text-lg font-bold text-brand-text" data-id="element-39">
          4. Acceso al contenido
        </h3>
        <p data-id="element-40">
          El acceso al material se habilita de forma instantánea tras
          confirmarse el pago. Es responsabilidad del usuario conservar de
          manera segura sus credenciales y materiales descargados.
        </p>
        <h3 className="text-lg font-bold text-brand-text" data-id="element-41">5. Modificaciones</h3>
        <p data-id="element-42">
          Nos reservamos el derecho de actualizar estos términos en cualquier
          momento. El uso continuado del producto implica la aceptación de las
          versiones vigentes.
        </p>
      </LegalModal>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-43">
        <p data-id="element-44">
          Tu privacidad es importante para nosotros. Esta política describe cómo
          tratamos la información asociada al uso del programa "Reinicio
          Metabólico 45+".
        </p>
        <h3 className="text-lg font-bold text-brand-text" data-id="element-45">
          1. Información que recopilamos
        </h3>
        <p data-id="element-46">
          Podemos recopilar la información necesaria para procesar tu compra y
          habilitar el acceso al producto, así como datos de navegación con
          fines de mejora del servicio.
        </p>
        <h3 className="text-lg font-bold text-brand-text" data-id="element-47">
          2. Uso de la información
        </h3>
        <p data-id="element-48">
          La información se utiliza únicamente para entregar el producto,
          brindar soporte relacionado con tu acceso y mejorar la experiencia de
          uso. No vendemos tu información a terceros.
        </p>
        <h3 className="text-lg font-bold text-brand-text" data-id="element-49">
          3. Protección de datos
        </h3>
        <p data-id="element-50">
          Aplicamos medidas razonables de seguridad para proteger tu información
          frente a accesos no autorizados, pérdida o uso indebido.
        </p>
        <h3 className="text-lg font-bold text-brand-text" data-id="element-51">4. Cookies</h3>
        <p data-id="element-52">
          Este sitio puede utilizar cookies para recordar tus preferencias y
          analizar el rendimiento de la página. Puedes administrar las cookies
          desde la configuración de tu navegador.
        </p>
        <h3 className="text-lg font-bold text-brand-text" data-id="element-53">5. Tus derechos</h3>
        <p data-id="element-54">
          Tienes derecho a solicitar el acceso, la rectificación o la
          eliminación de tu información personal conforme a la normativa
          aplicable.
        </p>
      </LegalModal>
    </footer>;
}